import { selectorFamily, SerializableParam, useRecoilValue } from 'recoil';
import { convertPaymentDetails } from 'functions';
import { PaymentService } from 'services';
import { isAuthenticated, refreshState, useSetRefreshState } from 'state';
import { PaymentDetail } from 'types';

type PaymentDetailParams = {
    accountId: string,
    vendorId: string,
    paymentId: string,
} & SerializableParam;

export const paymentDetails = selectorFamily<PaymentDetail[], PaymentDetailParams>({
    key: 'paymentDetails',
    get: ({ accountId, vendorId, paymentId }) =>
        async ({ get }) => {
            get(refreshState(paymentDetails({ accountId, vendorId, paymentId }).key))
            if (get(isAuthenticated) && accountId && vendorId && paymentId) {
                const service = new PaymentService();
                const data = await service.getPaymentDetails(accountId, vendorId, paymentId);
                return convertPaymentDetails(data);
            }
            return [];
        }
});

export const usePaymentDetails = (accountId: string, vendorId: string, paymentId: string) => 
    useRecoilValue(paymentDetails({ accountId, vendorId, paymentId }));

export const useRefreshPaymentDetails = (accountId: string, vendorId: string, paymentId: string) => 
    useSetRefreshState(paymentDetails({ accountId, vendorId, paymentId }));